import { rei } from "@/services/api"

class CartorioService {
  static getCartoriosRei () {
    return rei.get('/serventia')
  }

  static getCartorioRei (idCartorio) {
    return rei.get(`serventia/${idCartorio}`)
  }

  static updateCartorioRei (params) {
    return rei.put(`serventia/${params.cartorio_id}`, params)
  }

  static pesquisarCartorios (params) {
    return rei.get(`getCartorios`, { params })
  }

  static selecionarServentia () {
    return rei.post(`session/serventia/select`)
  }

  static updatePrimeiroAcesso (idCartorio) {
    return rei.post(`primeiro-acesso/${idCartorio}`)
  }

  static getChavesTJ (params) {
    return rei.get(`serventia/chavesTJ`, { params })
  }

  static getChavesEProtocolo (params) {
    return rei.get(`serventia/chavesEProtocolo`, { params })
  }

  static moduloCaixaStatus (cartorioId) {
    return rei.get(`serventia/modulo/caixa-status/${cartorioId}`)
  }

  static moduloMensalistaStatus (cartorioId) {
    return rei.get(`serventia/modulo/mensalista-status/${cartorioId}`)
  }
}

export default CartorioService
